<button mat-icon-button (click)="_openSettings($event)">
	<ogs-m3-icon icon="gear"/> 
</button>
